import * as React from "react";
import { SVGProps } from "react";
export const ButtonIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M3.5 15C3.0875 15 2.73438 14.8531 2.44062 14.5594C2.14687 14.2656 2 13.9125 2 13.5V6.5C2 6.0875 2.14687 5.73438 2.44062 5.44063C2.73438 5.14688 3.0875 5 3.5 5H16.5C16.9125 5 17.2656 5.14688 17.5594 5.44063C17.8531 5.73438 18 6.0875 18 6.5V13.5C18 13.9125 17.8531 14.2656 17.5594 14.5594C17.2656 14.8531 16.9125 15 16.5 15H3.5ZM3.5 13.5H16.5V6.5H3.5V13.5ZM6.25 10.75V11.75C6.25 11.9583 6.32292 12.1354 6.46875 12.2812C6.61458 12.4271 6.79167 12.5 7 12.5C7.20833 12.5 7.38542 12.4271 7.53125 12.2812C7.67708 12.1354 7.75 11.9583 7.75 11.75V10.75H8.75C8.96069 10.75 9.13486 10.6771 9.2725 10.5312C9.41028 10.3854 9.47917 10.2083 9.47917 10C9.47917 9.79167 9.40625 9.61458 9.26042 9.46875C9.11458 9.32292 8.9375 9.25 8.72917 9.25H7.75V8.25C7.75 8.04167 7.67708 7.86458 7.53125 7.71875C7.38542 7.57292 7.20833 7.5 7 7.5C6.79167 7.5 6.61458 7.57292 6.46875 7.71875C6.32292 7.86458 6.25 8.04167 6.25 8.25V9.25H5.25C5.04167 9.25 4.86458 9.32292 4.71875 9.46875C4.57292 9.61458 4.5 9.79167 4.5 10C4.5 10.2083 4.57292 10.3854 4.71875 10.5312C4.86458 10.6771 5.04167 10.75 5.25 10.75H6.25Z"
            fill="currentColor"
        />
    </svg>
);
ButtonIcon.displayName = "ButtonIcon";
